import store from '../../init/store.js'
import {getCombatantIdFromSelectingString} from '../get-combatant-id-from-selecting-string.js'


export function isSubmissionMenuOpen() {
  const {
    combatantSelectingAction,
    battlePlayerId,
    arenaSubmissionMenuCombatantIdLock
  } = store.getState().battle;

  if (!arenaSubmissionMenuCombatantIdLock) {
    //Do not show if this person's ID has already been nulled out after submitting
    //(see `arenaSubmitFinalAction`)
    return false;
  }

  //Show nothing if this person currently selecting person is not displayed.
  const useCombId = getCombatantIdFromSelectingString(combatantSelectingAction);
  if (!battlePlayerId.includes(useCombId)) {
    return false;
  }

  return true;
}


// WEBPACK FOOTER //
// ./src/battle/ArenaView/is-submission-menu-open.js